import React from 'react';
import PropTypes from 'prop-types';

import UnSyncInfo from './UnSyncInfo';
import SyncInfo from './SyncInfo';

function OCInfo({ onReset, synced, channelName, isAutoPreview }) {
  return synced ? (
    <SyncInfo channelName={channelName} isAutoPreview={isAutoPreview} />
  ) : (
    <UnSyncInfo
      channelName={channelName}
      onReset={onReset}
      isAutoPreview={isAutoPreview}
    />
  );
}

OCInfo.propTypes = {
  onReset: PropTypes.func,
  synced: PropTypes.boolean,
  channelName: PropTypes.string,
  isAutoPreview: PropTypes.bool,
};

OCInfo.defaultProps = {
  onReset: () => {
    /* */
  },
  synced: true,
  channelName: '',
  isAutoPreview: false,
};

export default React.memo(OCInfo);
